import { render, staticRenderFns } from "./integralshop.vue?vue&type=template&id=eb87b95a&scoped=true&"
import script from "./integralshop.vue?vue&type=script&lang=js&"
export * from "./integralshop.vue?vue&type=script&lang=js&"
import style0 from "./integralshop.vue?vue&type=style&index=0&id=eb87b95a&lang=scss&scoped=true&"
import style1 from "./integralshop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb87b95a",
  null
  
)

export default component.exports